import React, { useState } from 'react'
import './About.css'

const About = () => {
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  })

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setContactForm(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    alert('Thank you for your message! This is a demo version, so your information was not actually submitted.')
    setContactForm({
      name: '',
      email: '',
      subject: '',
      message: ''
    })
  }

  return (
    <div className="about-page">
      {/* Hero Banner */}
      <section 
        className="banner"
        style={{
          backgroundImage: 'url(/images/banner-home.jpg)'
        }}
      >
        <div className="wrapper">
          <div className="banner-content">
            <div className="gb-logo"></div>
            <h1>About Us</h1>
            <p>Building bridges between cultures and communities</p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section id="mission" className="section mission-section">
        <div className="wrapper">
          <div className="section-header">
            <h2>OUR MISSION</h2>
          </div>
          <blockquote className="quote">
            <p>Our mission is to build bridges to China that empower individuals and organizations to serve, inspire and transform lives</p>
          </blockquote>
          
          <div className="focus-areas">
            <h3>OUR FOCUS AREAS: KNOWLEDGE, NETWORKS, & YOUTH</h3>
            <div className="focus-grid">
              <div className="focus-item">
                <h4>Game-changing Ideas</h4>
                <p>We know that there is a hunger and desire to participate meaningfully in nonprofit efforts in China. However, actionable knowledge tends to be scarce, despite a lot of good intentions. We focus as a cross-cultural bridge on generating the kinds of exchanges, ideas, and frameworks that will strengthen the impact of philanthropic endeavors in China. Worthy intentions are simply not enough. But the right understanding and context can change everything.</p>
              </div>
              <div className="focus-item">
                <h4>Community Networks and Engagement</h4>
                <p>We believe in building online and offline bridges to strengthen community networks. Strong communities have the power to greatly enhance the capacity of individuals and organizations to serve a greater good.</p>
              </div>
              <div className="focus-item">
                <h4>Youth Study Abroad, Leadership and Education</h4>
                <p>We support initiatives that cultivate international student exchange programs and engage an inter-program network of study abroad advocates throughout the U.S. school system to help promote study abroad. As a young and youthful organization, we believe that we are uniquely positioned to help cultivate a more globally competent next generation that can act and help to shape a more civil, sustainable and peaceful future for China and the world.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* History Section */}
      <section id="history" className="section history-section">
        <div className="wrapper">
          <div className="section-header">
            <h2>OUR BEGINNINGS</h2>
          </div>
          <div className="history-content">
            <p>The Golden Bridges Foundation was founded in December 2007 to bridge the cultural gaps between China and the West through meaningful nonprofit and educational exchanges. We began with a simple idea to facilitate and place helpful international volunteers with Chinese NGOs. The 2008 Sichuan Earthquake opened our eyes to the great complexities and enormous needs of China's nonprofit world. After the earthquake, our commitment to serve Chinese charities turned into a quest to strengthen the nonprofit field.</p>
            
            <p>Today, we are a leading bridge-builder for many core philanthropic practitioners in China. We have a strong pulse on the frontlines of nonprofit developments, and hold a unique track record of breakthrough projects, having worked with over 100 nonprofits in China as an international facilitator and hands-on implementer.</p>
            
            <div className="accomplishments">
              <h3>Highlighted Accomplishments</h3>
              <ul>
                <li>Mobilizing the first major Chinese youth delegation to a UN climate conference</li>
                <li>Launching the China Foundation Center to catalyze philanthropic transparency in China</li>
                <li>Facilitating 300 simultaneous grassroots events in a single day to raise awareness of climate change across China</li>
                <li>Building ProjectPengyou.org, the alumni network of President Obama's 100,000 Strong Initiative, and the first online social network to strengthen US-China relations</li>
                <li>Developing the "Five Bucket" model to create a simplified mapping of China's nonprofit landscape</li>
              </ul>
              <p>Golden Bridges operates in Beijing through a locally-owned consultant company, and is registered as a 501(c)(3) tax-exempt public charity in San Francisco, CA.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Founder Section */}
      <section id="founder" className="section founder-section">
        <div className="wrapper">
          <div className="section-header">
            <h2>MEET HOLLY</h2>
          </div>
          <div className="founder-content">
            <div className="founder-image">
              <img src="/images/holly-chang.png" alt="Holly Chang" />
            </div>
            <div className="founder-bio">
              <p>Holly Chang is the Founder & President of The Golden Bridges Foundation. She is a Chinese-American social entrepreneur with demonstrated corporate and nonprofit success in China and the U.S.A. Born in Malaysia to Chinese parents, her family immigrated to Texas when she was four years old. Inspired by her own experiences of cultural conflict growing up, Holly left a rapid-climbing corporate career and invested her life savings to start the Golden Bridges Foundation in 2007 based on a vision of promoting "Diverse Cultures, Shared Humanity".</p>
              
              <p>While at Golden Bridges, Holly has served hundreds of nonprofit programs in China as an international bridge, and she has also held a number of important roles in other nonprofit organizations, including Vice President of International Relations at the China Foundation Center, and Executive Director of the Committee of 100, an influential Chinese American leadership organization. Holly holds a BS Civil Engineering and BS Psychology from University of Kentucky & MBA with thesis on the China market from Bellarmine University.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section id="values" className="section values-section">
        <div className="wrapper">
          <div className="section-header">
            <h2>OUR GOLDEN RULES</h2>
          </div>
          <div className="golden-rules-grid">
            <div className="golden-rule">
              <div className="rule-number">1</div>
              <div className="rule-content">
                <h3>DO NO HARM</h3>
                <p>Listen and Serve First</p>
              </div>
            </div>
            <div className="golden-rule">
              <div className="rule-number">2</div>
              <div className="rule-content">
                <h3>COMMIT TO INTEGRITY</h3>
                <p>Do what we say, say what we do</p>
              </div>
            </div>
            <div className="golden-rule">
              <div className="rule-number">3</div>
              <div className="rule-content">
                <h3>COMMIT TO EXCELLENCE</h3>
                <p>"Good is the Enemy of Great"</p>
              </div>
            </div>
            <div className="golden-rule">
              <div className="rule-number">4</div>
              <div className="rule-content">
                <h3>LEARN BY DOING</h3>
                <p>Avoid analysis paralysis, lean towards action</p>
              </div>
            </div>
            <div className="golden-rule">
              <div className="rule-number">5</div>
              <div className="rule-content">
                <h3>SERVE THROUGH PARTICIPATION</h3>
                <p>Engage stakeholders in solutions</p>
              </div>
            </div>
            <div className="golden-rule">
              <div className="rule-number">6</div>
              <div className="rule-content">
                <h3>REPLICATE "BRIGHT SPOTS"</h3>
                <p>Focus on and grow what works</p>
              </div>
            </div>
            <div className="golden-rule">
              <div className="rule-number">7</div>
              <div className="rule-content">
                <h3>ENGAGE IN NEW POSSIBILITIES</h3>
                <p>Mindset for innovation</p>
              </div>
            </div>
            <div className="golden-rule">
              <div className="rule-number">8</div>
              <div className="rule-content">
                <h3>CULTURE OF TRANSPARENCY</h3>
                <p>Constantly improve ways to communicate & document</p>
              </div>
            </div>
            <div className="golden-rule">
              <div className="rule-number">9</div>
              <div className="rule-content">
                <h3>ALWAYS HAVE GRATITUDE</h3>
                <p>Acknowledge the giants who's shoulders on which we stand</p>
              </div>
            </div>
            <div className="golden-rule">
              <div className="rule-number">10</div>
              <div className="rule-content">
                <h3>PUT THE FUN IN FUNCTIONAL</h3>
                <p>:P</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section id="team" className="section team-section">
        <div className="wrapper">
          <div className="section-header">
            <h2>OUR TEAM</h2>
          </div>
          <div className="team-grid">
            <div className="team-member">
              <div className="member-image">
                <img src="/images/holly-chang.png" alt="Holly Chang" />
              </div>
              <div className="member-info">
                <h3>Holly Chang</h3>
                <p className="role">Founder and President</p>
                <p>Leading the organization's strategic vision and program development from Beijing, China.</p>
              </div>
            </div>
            <div className="team-member">
              <div className="member-image">
                <img src="/images/alyssa-farrelly.png" alt="Alyssa Farrelly" />
              </div>
              <div className="member-info">
                <h3>Alyssa Farrelly</h3>
                <p className="role">Executive Director</p>
                <p>Overseeing program implementation and international partnerships. Alumna of American University.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Financials Section */}
      <section id="financials" className="section financials-section">
        <div className="wrapper">
          <div className="section-header">
            <h2>FINANCIAL TRANSPARENCY</h2>
          </div>
          <div className="financials-content">
            <p>The Golden Bridges Foundation is committed to financial transparency and accountability. As a registered 501(c)(3) nonprofit organization (EIN: 26-1559010), we ensure that our resources are used effectively to achieve our mission.</p>
            
            <div className="commitment-grid">
              <div className="commitment-item">
                <h3>Our Commitment</h3>
                <ul>
                  <li>Annual financial reports are available upon request</li>
                  <li>Donations are used efficiently to maximize program impact</li>
                  <li>Administrative costs are kept to a minimum</li>
                  <li>Regular third-party audits ensure financial integrity</li>
                </ul>
              </div>
              <div className="commitment-item">
                <h3>Financial Documents</h3>
                <ul className="document-links">
                  <li><a href="#" className="btn-download">Annual Report 2023 (PDF)</a></li>
                  <li><a href="#" className="btn-download">Form 990 (PDF)</a></li>
                  <li><a href="#" className="btn-download">Audited Financial Statements (PDF)</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="section contact-section">
        <div className="wrapper">
          <div className="section-header">
            <h2>CONTACT US</h2>
          </div>
          <div className="contact-grid">
            <div className="contact-info">
              <h3>Get In Touch</h3>
              <div className="contact-details">
                <div className="contact-item">
                  <span className="icon-phone"></span>
                  <p>+86-010-65157574</p>
                </div>
                <div className="contact-item">
                  <span className="icon-email"></span>
                  <p>info@goldenbridges.org</p>
                </div>
                <div className="contact-item">
                  <span className="icon-address"></span>
                  <p>
                    No.65 Xiaojingchang Hutong, Guloudong Ave,<br />
                    Dongcheng District, Beijing 100009
                  </p>
                </div>
              </div>
            </div>
            
            <div className="contact-form-container">
              <h3>Send Us a Message</h3>
              <form className="contact-form" onSubmit={handleSubmit}>
                <input
                  type="text"
                  name="name"
                  value={contactForm.name}
                  onChange={handleInputChange}
                  placeholder="Your Name"
                  required
                />
                <input
                  type="email"
                  name="email"
                  value={contactForm.email}
                  onChange={handleInputChange}
                  placeholder="Your Email"
                  required
                />
                <input
                  type="text"
                  name="subject"
                  value={contactForm.subject}
                  onChange={handleInputChange}
                  placeholder="Subject"
                  required
                />
                <textarea
                  name="message"
                  value={contactForm.message}
                  onChange={handleInputChange}
                  placeholder="Your Message"
                  rows="5"
                  required
                ></textarea>
                <button type="submit" className="btn-submit">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default About